// store/modules/trackingGeneral/actions.js
import TrackingGeneralApi from "../../../api/modules/TrackingGeneralApi";

export const getTrackingByChild = async ({commit}, payload) => {
  try {
    const {context, type, idChild} = payload;
    return await TrackingGeneralApi.getTrackingByChild(context, {type, idChild});
  } catch (error) {
    console.error("Error al obtener tracking:", error);
    throw error;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/trackingGeneral/actions.js